import { REACT_APP_MERCADO_PUBLICO_BASE_URL } from '../../config/settings/environment'

/**
 * Redirects to top of page.
 */
export const topPage = (isInIframe, open = true) => {
  if (open && isInIframe) {
    window.parent.postMessage(
      {
        action: 'scrollTo',
        value: {
          x: 0,
          y: 0
        }
      },
      REACT_APP_MERCADO_PUBLICO_BASE_URL
    )
  }
}
